import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '../../../../foundation/altzero_base/base/components/ui/sheet';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
};

export function ContractDrawer({ open, onClose, title, children }: Props) {
  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="right" className="w-full max-w-md overflow-y-auto">
        <SheetHeader className="mb-6">
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        {children}
      </SheetContent>
    </Sheet>
  );
}
